import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Table, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { type TextCarouselWebPageBlockDataFragment } from '../../../../api/fragments/TextCarouselWebPageBlockData';
import { type TranslatedStringDataFragment } from '../../../../api/fragments/TranslatedStringData';
import TranslatedMarkdownField from '../../../../components/fields/TranslatedMarkdownField';
import ResponsiveStyledTable from '../../../shared/ResponsiveStyledTable';
import { StyledIcon } from './shared';

type DescriptionTableProps = {
    descriptionsTable: TranslatedStringDataFragment[];
    remove: (index: number) => void;
    name: string;
    disabled?: boolean;
};

const DescriptionTable = ({ descriptionsTable, remove, name, disabled = false }: DescriptionTableProps) => {
    const { t } = useTranslation(['webpageDetails']);

    const buttonList = (index: number) => (
        <StyledIcon>
            {descriptionsTable.length > 1 && (
                <DeleteOutlined
                    onClick={() => {
                        remove(index);
                    }}
                    style={{ color: 'var(--ant-primary-color)' }}
                />
            )}
        </StyledIcon>
    );

    return (
        <ResponsiveStyledTable
            dataSource={descriptionsTable}
            pagination={false}
            rowKey={(row, index: number) => `${name}_${index.toString()}`}
        >
            <Table.Column<TextCarouselWebPageBlockDataFragment['textDescriptions']>
                dataIndex="content"
                render={(value, record, index) => (
                    <TranslatedMarkdownField
                        commands={[]}
                        disabled={disabled}
                        label=""
                        name={`${name}.[${index}]`}
                        required={false}
                    />
                )}
                title={
                    <>
                        {t('webpageDetails:fields.textCarousel.descriptions.label')}
                        <Tooltip title={t('webpageDetails:fields.textCarousel.descriptions.info')}>
                            <InfoCircleOutlined style={{ marginLeft: '4px' }} />
                        </Tooltip>
                    </>
                }
            />
            {!disabled && (
                <Table.Column
                    key="actions"
                    align="center"
                    render={(value, record, index) => buttonList(index)}
                    title={t('webpageDetails:actions.action')}
                    width={100}
                />
            )}
        </ResponsiveStyledTable>
    );
};

export default DescriptionTable;
